import { ApiClient } from '../../api/client/ApiClient'
import { apiOps } from '../../api/defs/apiOps'

export class NewsletterApi {
    constructor(private api: ApiClient) {}

    subscribe = (): Promise<void> =>
        this.api.do(apiOps.MyZone.subscribeToNewsletter)

    isSubscribed = (): Promise<boolean> =>
        this.api.do(apiOps.MyZone.isSubscribedToNewsletter)
}
